import {
  EssSection,
  EssTopic,
} from '@/domain/impact-ess/entities/question.entity';

/**
 * Retireve topics in combobox on top of form side panel
 */
export function prepareEssTopicsDisplayed(
  essQuizLayout: Record<EssTopic, { sections: Array<EssSection> }>,
): EssTopic[] {
  return Object.keys(essQuizLayout)
    .filter((x) => essQuizLayout[x as EssTopic].sections.length > 0)
    .map((x) => x as EssTopic);
}
